














































































































































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import AuthService from "../services/auth-service";
import moment from "moment";

declare var amp: any;

@Component({})
export default class AcademicCalendar extends Vue {
  private service = new GeneralService();
  private auth = new AuthService();
  private level_id = JSON.parse(localStorage[config.programSelect] || null);

  private calendarData: any = [];
  private weekData: any = [];
  private currentWeekData: any = [];
  private currentWeekSubjects: any = [];
  private currentWeek = 1;
  private currentMonthRange = "";
  private academicYearRange = "";
  private currentVideoTitle = "";
  private currentVideoLink = "";
  private paginationKey = 0;
  private gotData = false;
  private srcToken: any;
  private ifQuestionExists = false;
  private currentSubject = "";
  private dataKey = 0;
  private playVideo = false;
  private playerKey = 0;
  private sending = false;
  private sentQuestion = false;
  private question = "";
  private sourceLoaded = false;
  private teacherID = "";
  private subjectID = "";
  private teacherName = "";
  private classSection = "";
  private teacherData: any = [];
  public valuename: any = {};
  public storedInfo: any = [];
  public studentData: any = [];

  private player: any;

  private backButton() {
    this.player.pause();
    this.playVideo = false;
  }

  private displayDay(day) {
    console.log(day);
  }

  private findDate(arr){
    for (let i = 0; i < arr.length; i++){
      if (arr[i].dateRange !== "")
        return arr[i].dateRange;
    }
  }

  private findLastDate(arr){
    for (let i = arr.length-1; i >=0; i--){
      if (arr[i].dateRange !== "")
        return arr[i].dateRange;
    }
  }

  private changeWeek(page) {
    this.currentWeek = page;
    this.currentWeekData = [... this.weekData[page - 1]];
    
    this.currentMonthRange =
      moment(this.findDate(this.weekData[page - 1])).format("DD MMM") +
      " - " +
      moment(
        this.findLastDate(this.weekData[page - 1])
      ).format("DD MMM");

    this.currentWeekData = this.currentWeekData.sort((a, b) => {
      return a.courseName > b.courseName ? -1 : 1;
    });

    this.currentWeekData.sort((a,b) => {
      if (a.code == 'LP' && b.code =='LP')
        return a.dateRange > b.dateRange ? 1 : -1;
      else if (a.code == 'LP')
        return -1;
      else if (b.code == 'LP')
        return 1;
      else
        return a.dateRange > b.dateRange ? 1 : -1;
    });

    if (this.currentWeekData.length == 0) this.gotData = false;
    else this.gotData = true;


    this.currentWeekData = this.currentWeekData.filter(function (item, pos, self) {
      for (let i=0; i < self.length; i++){
        if (item.code !== 'LP') {
          return true
        }
        
        if (self[i].chapterName == item.chapterName && self[i].topicDescription == item.topicDescription){
          return i == pos;
        } 
      }
    });

    let prevDate = "";
    let prevSubject = "";
    for (let i = 0; i < this.currentWeekData.length; i++) {
      if (
        prevDate == this.currentWeekData[i].dateRange &&
        prevSubject == this.currentWeekData[i].courseName
      ) {
        prevDate = this.currentWeekData[i].dateRange;
        this.currentWeekData[i].dateRange = "";
      } else {
        prevDate = this.currentWeekData[i].dateRange;
      }

      prevSubject = this.currentWeekData[i].courseName;
    }

    this.currentWeekSubjects = this.getSubjects(this.weekData[page - 1]).sort();
    this.currentSubject = this.currentWeekSubjects[0];
  }

  private findWeek(week) {
    for (let i = 0; i < this.calendarData.length; i++) {
      if (week == this.calendarData[i].yearlyWeekNo) {
        this.changeWeek(this.calendarData[i].weekNo - 1);
        return;
      }
    }

    this.changeWeek(1);
  }

  private askQuestion() {
    let data = {
      device_Id:
      this.auth.session.userName.split("@")[0] +
      window.navigator.userAgent.replace(/\D+/g, ""),
      application_Version: "1.4.8",
      Student_ID: this.auth.session.userName.split("@")[0],
      Teacher_ID: this.teacherID,
      Question: this.question,
      userMacAddress: "dsdd",
      Subject_ID: this.subjectID,
      Section_ID: this.classSection,
      From: this.teacherName,
      Topic: this.$store.state.chapterSelectName,
      application_Name: "PGC",
    };

    if (this.sending == false) {
      this.sending = true;
      this.service.sendQuestion(data, false).then((response) => {
        this.sending = false;
        if (response.message.messageTypeId == "Success") {
          this.sentQuestion = true;
        } else {
          alert(
            "Your question could not be asked at this time. Please try again later"
          );
          throw response.message.messageTypeId;
        }
      });
    }
  }

  private getSubjects(data) {
    let subjects: any = [];
    for (let i = 0; i < data.length; i++) {
      if (!subjects.includes(data[i].courseName)) {
        subjects.push(data[i].courseName);
      }
    }

    return subjects;
  }

  private playClicked(name, link, subject) {
    this.currentVideoTitle = name;
    this.currentVideoLink = link;
    for (const teacher of this.teacherData) {
      if (teacher.subject_Name == subject) {
        this.ifQuestionExists = true;
        this.teacherID = teacher.teacher_ID;
        this.subjectID = teacher.subject_ID;
        this.teacherName = teacher.teacher_Name;
      }
    }
    this.playVideo = true;
    this.loadVideo();
  }

  private parseDate(date) {
    return moment(date).format("DD MMM YY");
  }

  private makeSubjectsArray(subjects) {
    let array: any = [];

    for (let i = 0; i < subjects.length; i++) array[subjects[i]] = [];

    return array;
  }

  private makeArray(weeks) {
    let array: any = [];

    for (let i = 0; i < weeks; i++) array[i] = [];

    return array;
  }

  private getData(calendarData) {
    let weekData: any = this.makeArray(
      calendarData[calendarData.length - 1].weekNo
    );
    for (let i = 0; i < calendarData.length; i++) {
      weekData[calendarData[i].weekNo - 1].push(calendarData[i]);
    }

    return weekData;
  }

  private checkBrowser(src, calback) {
    let brow = "widevine";
    if (this.$browserDetect.isEdge || this.$browserDetect.isIE) {
      brow = "playReady";
    }
    if (this.$browserDetect.isSafari) {
      brow = "clear";
    }
    this.getToken(src, brow, (data) => {
      calback(data);
    });
  }

  private getToken(source, brow, callback) {
    this.service
      .getVideoToken(source, brow)
      .then((result) => {
        this.srcToken = result;
        callback(result);

        this.player.src([
          {
            src: result.src, //response.src,
            type: "application/vnd.ms-sstr+xml", //response.type,
            protectionInfo: [
              {
                type: result.protectionInfo.type,
                certificateUrl: result.protectionInfo.certificateUrl,
                authenticationToken: result.protectionInfo.authenticationToken,
              },
            ],
          },
        ]);
      })
      .catch((err) => {
        console.error(`Error: ${err.message}`);
      });
  }

  private loadVideo() {
    window.scrollTo(0, 0);
    console.log(this.currentVideoLink)
    this.checkBrowser(this.currentVideoLink, (data) => {
      this.loadVideoEx();
    });
  }

  private loadVideoEx() {
    let client = document.getElementById("main-content");
    if (client !== null) {
      this.player = amp("azuremediaplayer", {
        nativeControlsForTouch: false,
        logo: { enabled: false },
        autoplay: false,
        fluid: true,
        playbackSpeed: {
          enabled: true,
          initialSpeed: 1.0,
          speedLevels: [
            { name: "x4.0", value: 4.0 },
            { name: "x3.0", value: 3.0 },
            { name: "x2.0", value: 2.0 },
            { name: "x1.75", value: 1.75 },
            { name: "x1.5", value: 1.5 },
            { name: "x1.25", value: 1.25 },
            { name: "normal", value: 1.0 },
            { name: "x0.75", value: 0.75 },
            { name: "x0.5", value: 0.5 },
          ],
        },
        controls: true,
        width: "auto",
        height: 600,
        techOrder: [
          "azureHtml5JS",
          "flashSS",
          "html5FairPlayHLS",
          "silverlightSS",
          "html5",
        ],
      });

    }

    this.player.src([
      {
        src: this.srcToken.src, //response.src,
        type: this.srcToken.Type, //response.type,
        protectionInfo: [
          {
            type: this.srcToken.protectionInfo.type,
            certificateUrl: this.srcToken.protectionInfo.certificateUrl,
            authenticationToken:
              this.srcToken.protectionInfo.authenticationToken,
          },
        ],
      },
    ]);

    this.sourceLoaded = true;
  }

  findClass(cls: string, arr: Array<any>) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].Class.indexOf(cls) > -1 || arr[i].Class.toLowerCase().indexOf('pre') > -1) return arr[i];
    }

    return null;
  }

  async mounted() {
    let username = this.auth.session.userName.split("@")[0];
    let currentWeek = moment().week();

    // Fetch valuename for Program/Class display
    this.service.getInfoEMS(username).then((result) => {
      if (result && result.data && result.data.length > 0) {
        this.studentData = result.data;
        this.storedInfo = localStorage.getItem(config.studentPartInfo);
        let storedArr = typeof this.storedInfo === 'string' ? JSON.parse(this.storedInfo) : this.storedInfo;
        let currentPart = storedArr.find(p => p.fullName === this.level_id.part);
        this.valuename = currentPart ? this.studentData.find(e => e.Class === currentPart.fullName) : {};
      }
    }).catch((err) => {
      console.error('Error fetching student info:', err);
    });

    this.service.getInfoEMS(username).then((userdata) => {
      let currentData;
      if (this.level_id.part.indexOf("II") > -1) {
        currentData = this.findClass("II", userdata.data);
      } else {
        currentData = this.findClass("I", userdata.data);
      }
      this.classSection = userdata.data[0].Class_section_id;
      let admissionID = currentData.Admission_Form_ID;
      let clid = currentData.Class_Level_ID;

      this.service.getAcademicCalendar(admissionID, clid).then((result) => {
        this.calendarData = result.data.Data;
        this.calendarData.sort((a, b) => {
          return moment(a.dateRange) > moment(b.dateRange) ? 1 : -1;
        });
        this.academicYearRange =
          moment(this.calendarData[0].dateRange).format("MMM, YYYY") +
          " - " +
          moment(
            this.calendarData[this.calendarData.length - 1].dateRange
          ).format("MMM, YYYY");
        this.weekData = this.getData(result.data.Data);
        this.paginationKey++;
        this.dataKey++;
        this.gotData = true;
        // this.changeWeek(1);
        this.findWeek(currentWeek);
      });
    });

    this.service
      .getTeacherSubject(
        this.auth.session.userName.split("@")[0],
        localStorage[config.deviceId]
      )
      .then((result) => {
        this.teacherData = result.data.Data;
      });

    this.player = amp("azuremediaplayer", {
      nativeControlsForTouch: false,
      logo: { enabled: false },
      autoplay: true,
      fluid: true,
      playbackSpeed: {
        enabled: true,
        initialSpeed: 1.0,
        speedLevels: [
          { name: "x4.0", value: 4.0 },
          { name: "x3.0", value: 3.0 },
          { name: "x2.0", value: 2.0 },
          { name: "x1.75", value: 1.75 },
          { name: "x1.5", value: 1.5 },
          { name: "x1.25", value: 1.25 },
          { name: "normal", value: 1.0 },
          { name: "x0.75", value: 0.75 },
          { name: "x0.5", value: 0.5 },
        ],
      },
      controls: true,
      width: "auto",
      height: 600,
      techOrder: [
        "azureHtml5JS",
        "flashSS",
        "html5FairPlayHLS",
        "silverlightSS",
        "html5",
      ],
    });
  }
}
